import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

export default class SanctionsWarningRows extends Component {

    static propTypes = {
        sanctionedEntities:     PropTypes.array
    };

    static defaultProps = {
        sanctionedEntities: []
    };

    render() {

        return (

            <tbody>

                {
                    this.props.sanctionedEntities.length > 0 ?
                        this.props.sanctionedEntities.map((company, index) =>
                            <tr key={"sanctioned-entity-" + index}>
                                <td className="entity-title">
                                    <SingleEntity entityTitle={this.props.sanctionedEntities[index].title}
                                                  companyId={this.props.sanctionedEntities[index].id} />
                                </td>
                            </tr>
                        ) :
                        <tr className="empty-entities">
                            <td colSpan="8">
                                <b><FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.noEntitiesWithSanctionsPart1" /></b> <FormattedMessage id="Dashboard_Charts_UIText_dashboard.sanctionsPod.noEntitiesWithSanctionsPart2" />
                            </td>
                        </tr>
                }

            </tbody>

        );

    };

}

export function SingleEntity({entityTitle, companyId}) {
    return (
        <Link to={`/sanctions-reports/company/${companyId}`}>{entityTitle}</Link>
    )
}



// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/SanctionsWarningPod/SanctionsWarningPod.Rows.jsx